import { useEffect, useRef } from "react";
import supabase from "../supabase-client";

// Live updates for one service row.
//
// A payout settles asynchronously (~13s live) and the confirmation dialog may
// already be closed — especially on the `pending_timeout` path, which ends with
// "sigue en proceso" and previously never followed up. Subscribing means the
// page reflects the real outcome without anyone reloading.
//
// The callback is held in a ref so an inline arrow does not tear down and
// rebuild the websocket on every render.
export function useServiceLive(serviceId, onServiceChange, enabled = true) {
  const cb = useRef(onServiceChange);
  cb.current = onServiceChange;

  useEffect(() => {
    if (!enabled || !serviceId) return undefined;

    const channel = supabase
      .channel(`service-live-${serviceId}`)
      .on(
        "postgres_changes",
        {
          event: "UPDATE",
          schema: "public",
          table: "services",
          filter: `id=eq.${serviceId}`,
        },
        (payload) => {
          if (payload?.new) cb.current?.(payload.new);
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [serviceId, enabled]);
}
